import {useDialogContext} from "../../dialogs/hooks/useDialogContext";

export const useChangesDialog = () => useDialogContext('changes');
